import { useForm } from "@inertiajs/react";
import { type SubmitEvent } from "react";
import DriverCarForm, {
  type DriverCarFormData,
} from "@/pages/driver_cars/_form";
import OnboardingShell from "@/shared/onboarding/OnboardingShell";
import { onboardingLayout } from "@/layouts/OnboardingLayout";
import type { OnboardingCarProps } from "@/types/onboarding";

// The regular car form, posted to its regular endpoint with `onboarding=1` so
// DriverCarsController sends them back here.
export default function OnboardingCar({
  participant,
  color_families,
  aspirations,
  errors,
  ...shell
}: OnboardingCarProps) {
  const { data, setData, post, processing } = useForm<DriverCarFormData>({
    participant,
    driver_car: {
      driver_name: "",
      make: "",
      model: "",
      chassis_code: "",
      year: null,
      trim: "",
      engine: "",
      aspiration: null,
      charger: "",
      hp: null,
      torque: null,
      color_family: "",
      body_kit: "",
      wheels: "",
      new_photos: [],
    },
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    post("/driver_cars?onboarding=1", { forceFormData: true });
  };

  return (
    <OnboardingShell
      {...shell}
      title="Add your car"
      subtitle="It shows up when you apply to drive and on the events you say you were at."
    >
      <DriverCarForm
        data={data}
        setData={setData}
        onSubmit={handleSubmit}
        processing={processing}
        errors={errors ?? undefined}
        title="Your car"
        subtitle="Photos are optional. You can add more cars later."
        submitLabel="Save and continue"
        colorFamilies={color_families}
        aspirations={aspirations}
        photos={[]}
        cancelPath={null}
      />
    </OnboardingShell>
  );
}

OnboardingCar.layout = onboardingLayout;
